module.exports = __webpack_public_path__ + "static/team-4-9f8038925d837f9d3c56176a9af4fe8e.jpg";